import React, { useState } from 'react'

import { normalizeTwoWords, formatImageAlt, findRel } from "../../../shared/utils/stringUtilities";
import ShareModal from '../../molecules/share-modal/shareModal'

import './cardVideo.scss'
interface CardVideoInter {
  video: any
}

const CardVideo = (props: CardVideoInter) => {
  const { video } = props

  const [isModalVisible, setIsModalVisible] = useState(false);

  const toggleModal = () => {
    setIsModalVisible(!isModalVisible);
  };

  return (
    <div className='a-card-video'>
      <a className='a-card-video__vid' href={video.redireccionBoton} rel={findRel(video.redireccionBoton)}>
        <img
          src={video.imagenPrincipal[0].file.url}
          alt={video.imagenPrincipal[0].title ? formatImageAlt(video.imagenPrincipal[0].title) : `Video ${video.tituloBanner}`}
          className={`gtm${normalizeTwoWords(video.gtmClass)}VideoClicVideo${normalizeTwoWords(video.tituloBanner)} `}
        />
        <div className='a-card-video__vid-circle'>
          <p className='icon-play a-card-video__vid-circle__play' />
        </div>
      </a>

      <a className='a-card-video__description' href={video.redireccionBoton} rel={findRel(video.redireccionBoton)}>
        <h3>{video.tituloBanner}</h3>
      </a>

      <hr className='a-card-video__separator' />

      <div className='a-card-video__icons'>
        <div
          className={`a-card-video__icons-share gtm${normalizeTwoWords(video.gtmClass)}VideoClicVideo${normalizeTwoWords(video.tituloBanner)}`}
          onClick={toggleModal}
        >
          <p className='icon-share a-card-video__icons-share__icon'></p>
        </div>
      </div>
      <ShareModal open={isModalVisible} onClose={toggleModal} href={video.redireccionBoton} />
    </div>
  )
}

export default CardVideo;
